class CopperGypsyFaq extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-cg-faq-item]')];
    this.dialog = this.querySelector('[data-cg-wholesale-dialog]');

    this.addEventListener('click', this.#handleClick);
    window.addEventListener('resize', this.#handleResize);
    this.items.forEach((item) => this.#syncItem(item, item.dataset.open === 'true'));

    if (this.dialog) {
      this.dialog.addEventListener('click', this.#handleDialogClick);
      this.dialog.addEventListener('cancel', this.#handleDialogCancel);

      if (this.dialog.querySelector('[data-contact-feedback]')) {
        this.#openDialog();
        this.dialog.querySelector('[data-contact-feedback]')?.focus();
      }
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    window.removeEventListener('resize', this.#handleResize);
    this.dialog?.removeEventListener('click', this.#handleDialogClick);
    this.dialog?.removeEventListener('cancel', this.#handleDialogCancel);
  }

  #handleClick = (event) => {
    const faqTrigger = event.target.closest('[data-cg-faq-trigger]');
    if (faqTrigger && this.contains(faqTrigger)) {
      const item = faqTrigger.closest('[data-cg-faq-item]');
      if (item) this.#toggleItem(item);
      return;
    }

    const openButton = event.target.closest('[data-cg-open-contact]');
    if (openButton && this.contains(openButton)) this.#openDialog();
  };

  #handleDialogClick = (event) => {
    if (event.target === this.dialog || event.target.closest('[data-cg-close-contact]')) {
      this.#closeDialog();
    }
  };

  #handleDialogCancel = (event) => {
    event.preventDefault();
    this.#closeDialog();
  };

  #handleResize = () => {
    const openItem = this.items.find((item) => item.dataset.open === 'true');
    if (!openItem) return;

    const panel = openItem.querySelector('[data-cg-faq-panel]');
    if (panel) panel.style.setProperty('--cg-faq-panel-height', `${this.#measurePanel(panel)}px`);
  };

  #toggleItem(item) {
    const isOpen = item.dataset.open === 'true';
    const currentlyOpen = this.items.find((faqItem) => faqItem.dataset.open === 'true');

    if (isOpen) {
      this.#syncItem(item, false);
      return;
    }

    if (currentlyOpen) this.#syncItem(currentlyOpen, false);

    window.setTimeout(() => {
      this.#syncItem(item, true);
    }, 20);
  }

  #syncItem(item, open) {
    const trigger = item.querySelector('[data-cg-faq-trigger]');
    const panel = item.querySelector('[data-cg-faq-panel]');

    item.dataset.open = String(open);
    trigger?.setAttribute('aria-expanded', String(open));
    panel?.setAttribute('aria-hidden', String(!open));

    if (open && panel) panel.style.setProperty('--cg-faq-panel-height', `${this.#measurePanel(panel)}px`);
  }

  #measurePanel(panel) {
    const panelInner = panel.querySelector('.cg-faq-item__panel-inner');
    const previousMaxHeight = panel.style.maxHeight;
    const previousTransition = panelInner?.style.transition;

    // Measure the fully open panel before the padding transition can report its starting height.
    if (panelInner) panelInner.style.transition = 'none';
    panel.style.maxHeight = 'none';
    void panel.offsetHeight;
    const height = panel.scrollHeight;
    panel.style.maxHeight = previousMaxHeight;
    if (panelInner) panelInner.style.transition = previousTransition;
    return height;
  }

  #openDialog() {
    if (!this.dialog || this.dialog.open) return;

    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }

    window.requestAnimationFrame(() => {
      this.dialog.querySelector('input, select, textarea, button')?.focus();
    });
  }

  #closeDialog() {
    if (!this.dialog) return;

    if (typeof this.dialog.close === 'function' && this.dialog.open) {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
    }
  }
}

if (!customElements.get('copper-gypsy-faq')) {
  customElements.define('copper-gypsy-faq', CopperGypsyFaq);
}
